module.exports = __webpack_public_path__ + "img/fast_rewind-24px.802cfa5b.svg";